export enum GtmEventCategory {
  LeadGeneration = 'LeadGeneration',
  ContactUs = 'contact_us',
}
